module.exports = __webpack_public_path__ + "img/12.41ee5197.jpg";